import { gql, useQuery } from '@apollo/client';
import { useMemo } from 'react';
import { getTranslatedString } from 'helpers/utils-typescript';

const CURRENTLY_PLAYING_QUESTS = gql`
query currentlyPlayingQuests($currentUserId: UUID!) {
  activeMultiplayerGames: routeMultiplayerGames(
    filter: {
      status: {equalTo: IN_PROGRESS}
      players: {anyEqualTo: $currentUserId}
    }
  ) {
    nodes {
      id
      updatedAt
      route {
        id
        slug
        name
      }
    }
  }
}
`;

export type CurrentlyPlayingQuest = {
  id: string;
  routeId: string;
  name: string;
  url: string;
  mode: 'multiplayer';
  lastActiveAt?: string;
};

const useCurrentlyPlayingQuests = (currentUserId?: string, currentLang = 'en') => {
  const { data, loading, error, refetch } = useQuery(CURRENTLY_PLAYING_QUESTS, {
    variables: {
      currentUserId,
    },
    skip: !currentUserId,
    fetchPolicy: 'network-only',
    pollInterval: 10000,
  });

  const quests = useMemo(() => {
    return (data?.activeMultiplayerGames?.nodes
      ?.filter((game: any) => game?.id && game?.route?.id && game?.route?.slug)
      ?.map((game: any) => {
        const route = game.route;

        return {
          id: game.id,
          routeId: route.id,
          name: getTranslatedString(route.name, currentLang) || route.slug,
          url: `/quest/${route.slug}/multiplayer/${game.id}`,
          mode: 'multiplayer' as const,
          lastActiveAt: game.updatedAt,
        };
      }) || []) as CurrentlyPlayingQuest[];
  }, [currentLang, data]);

  return {
    error,
    hasPlayingQuests: quests.length > 0,
    loading,
    quests,
    refetch,
  };
};

export default useCurrentlyPlayingQuests;
